import Vue from "vue";
import Vuetify from "vuetify/lib";
import * as VueMenu from "@hscmap/vue-menu";
Vue.use(VueMenu);
Vue.use(Vuetify, {
  theme: {
    primary: "#279947"
  }
});
export default new Vuetify({
  icons: {
    iconfont: "fa"
  },
  theme: {
    themes: {
      light: {
        primary: '#212121',
        secondary: '#000000',
        accent: '#000000',
        error: '#F44336',
        dirty: "#F44336",
        distributionColor: '#de6400',
        fercamColor: '#43207c'
      }
    }
  }
});
